import { STUDY_SESSION_TYPES } from 'my-core/study-session-utils';
import { getUserDisplayName } from 'my-core/user-utils';

import MuiAvatar from 'my-elements/MuiAvatar';
import SubjectIcon from 'my-elements/SubjectIcon';

export default function StudySessionCoverArt({ course, instructor, partLabel, studySession }) {
  const typeConfig = STUDY_SESSION_TYPES[studySession.type];
  return (
    <div
      css={({ palette, typography }) => ({
        width: '100%',
        height: '100%',
        position: 'relative',
        containerType: 'inline-size',
        background: `repeating-conic-gradient(from var(--ssca-rotation) at 75% 35%, ${palette[typeConfig.color].main} 0 10deg, ${palette[typeConfig.color].medium} 10deg 20deg)`,
        backgroundColor: palette[typeConfig.color].main,
        animation: 'ssca-rotate 200s linear infinite',

        '& > *': {
          position: 'absolute',
        },

        '& > .product-image': {
          width: '40%',
          height: 'auto',
          top: '5%',
          right: '5%',
        },
        '& > .contents-wrapper': {
          fontSize: '2.5cqw',
          width: '50%',
          top: 0,
          left: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '1em',
          justifyContent: 'center',
          alignItems: 'center',
        },
        '& .chip-wrapper': {
          borderRadius: '500px',
          backgroundColor: palette[typeConfig.color].dark,
          color: palette.common.white,
          padding: '0.25em 0.5em 0.25em 0.25em',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5em',
          '& > .chip-img': {
            fontSize: 'inherit',
            width: '2em',
            height: 'auto',
            aspectRatio: 1,
            borderRadius: '50%',
            backgroundColor: palette[typeConfig.color].main,
          },
          '& > span': {
            fontSize: '1em',
          },
        },

        '& .title-wrapper': {
          backgroundColor: palette.common.white,
          border: `0.25em solid ${palette[typeConfig.color].dark}`,
          borderRadius: '2em',
          padding: '0.5em 1.5em',
          textAlign: 'center',
          maxWidth: '90%',
          '& > h6': {
            color: palette[typeConfig.color].dark,
            fontSize: '1em',
            margin: 0,
          },
          '& > h3': {
            color: palette[typeConfig.color].main,
            fontSize: '3em',
            textTransform: 'uppercase',
            fontWeight: typography.fontWeightBlack,
            margin: 0,
          },
        },

        '@property --ssca-rotation': {
          syntax: "'<angle>'",
          inherits: 'false',
          initialValue: '0deg',
        },

        '@keyframes ssca-rotate': {
          from: {
            '--ssca-rotation': '0deg',
          },
          to: {
            '--ssca-rotation': '360deg',
          },
        },
      })}
    >
      <img className="product-image" src={typeConfig.image} />

      <div className="contents-wrapper">
        <div className="chip-wrapper">
          <SubjectIcon className="chip-img" course={course} />
          <span>{course.code}</span>
        </div>
        <div className="title-wrapper">
          <h6>{studySession.title}</h6>
          {partLabel && <h3>{partLabel}</h3>}
        </div>
        {instructor && (
          <div className="chip-wrapper">
            <MuiAvatar className="chip-img" src="thumb" user={instructor} />
            <span>With {getUserDisplayName(instructor)}</span>
          </div>
        )}
      </div>
    </div>
  );
}
